<template>
  <div v-loading="loading">
    <el-card>
      <el-form
        :model="projectForm"
        id="projectForm"
        ref="projectForm"
        label-width="200px"
        size="small"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-form-item label="Distribution code">
          {{ projectForm.distribution_code }}
        </el-form-item>
        <el-form-item label="Project Name">
          {{ projectForm.project_name }}
        </el-form-item>
        <el-form-item label="Discription">
          {{ projectForm.discription }}
   
        </el-form-item>

        <el-form-item label="Webhook bank" prop="webhook_bank">
          <el-input
            v-model="projectForm.webhook_bank"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook bank key" prop="webhook_bank_key">
          <el-input
            v-model="projectForm.webhook_bank_key"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook transaction" prop="webhook_transaction">
          <el-input
            v-model="projectForm.webhook_transaction"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook transaction key" prop="webhook_transaction_key">
          <el-input
            v-model="projectForm.webhook_transaction_key"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitConfig" :loading="submitting">Submit</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  getWebhook,
  updateWebhook
} from '@/api/project';
export default {
  props: {
    project: String,
  },
  watch: {
    project(val, old) {
      this.getWebhookConfig();
    },
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      errMsg: "",
      projectForm: {
        project_name: "",
        distribution_code: "",
        discription: "",
        webhook_bank: "",
        webhook_bank_key: "",
        webhook_transaction: "",
        webhook_transaction_key: "",
      },
    };
  },
  methods: {
    getWebhookConfig() {
      if(!this.project){
        return;
      }
      this.loading = true;
      this.errMsg = ""
      getWebhook(this.project).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.projectForm.project_name = data.project_name;
          this.projectForm.distribution_code = data.distribution_code;
          this.projectForm.discription = data.discription;
          this.projectForm.webhook_bank = data.webhook_bank;
          this.projectForm.webhook_bank_key = data.webhook_bank_key;
          this.projectForm.webhook_transaction = data.webhook_transaction;
          this.projectForm.webhook_transaction_key = data.webhook_transaction_key;
        }else{
          this.errMsg = message
        }
      });
    },
    mapData(){
      const formData = {
        webhook_bank: this.projectForm.webhook_bank,
        webhook_bank_key: this.projectForm.webhook_bank_key,
        webhook_transaction: this.projectForm.webhook_transaction,
        webhook_transaction_key: this.projectForm.webhook_transaction_key
      }
      return formData
    },
    submitConfig(){
      const formData = this.mapData()
      this.submitting = true
      this.errMsg = ''
      updateWebhook(this.project, formData).then(({ result, message}) =>{
        this.submitting = false
        if(result){
          this.$notify({
            title: 'Success',
            message: `Update Project successfully`,
            type: 'success',
            duration: 2000
          });
        }else{
          this.errMsg = message
        }
      })
    }
  },
  mounted() {
    this.getWebhookConfig();
  },
};
</script>

<style lang="scss" scoped></style>
